import common from "@/js/common"; // 경로 확인 필요

// 필요한 차트 컴포넌트 임포트 (resolveChartComponent에서 사용)
import FCSTSummary from '@/components/common/dashboard/chart/FCSTSummary.vue'
import PipelineManagement from '@/components/common/dashboard/chart/PipelineManagement.vue'
import FinalBalanceFCST from '@/components/common/dashboard/chart/FinalBalanceFCST.vue'
import PipelineHygiene from '@/components/common/dashboard/chart/PipelineHygiene.vue'
import TotalRevFCST from '@/components/common/dashboard/chart/TotalRevFCST.vue'
import TotalGMFCST from '@/components/common/dashboard/chart/TotalGMFCST.vue'
import RevFCST from '@/components/common/dashboard/chart/RevFCST.vue'
import GMFCST from '@/components/common/dashboard/chart/GMFCST.vue'
import MonthlyRevGMFCST from '@/components/common/dashboard/chart/MonthlyRevGMFCST.vue'
import PipelineStatus from '@/components/common/dashboard/chart/PipelineStatus.vue'
import WeeklyHistory from '@/components/common/dashboard/chart/WeeklyHistory.vue'


// 범례 옵션 상수
const SELECT_OPTIONS_LEGEND = [
  { text: '영업 대표', value: 'chief' },
  { text: '영업 기회', value: 'opportunity' },
  { text: 'End User', value: 'enduser' },
  { text: 'Stage', value: 'stage' },
  { text: '상품', value: 'goods' },
  { text: '매입처', value: 'purchaser' },
  { text: '전체', value: 'all' },
  { text: 'Q1', value: '1' },
  { text: 'Q2', value: '2' },
  { text: 'Q3', value: '3' },
  { text: 'Q4', value: '4' }
];

// 회계연도 표시 여부
export function shouldDisplayFiscalYear(itemName) {
  const list = [
    { name: 'Total Rev. FCST' }, { name: 'Total GM FCST' }, { name: 'Rev. FCST' },
    { name: 'GM FCST' }, { name: 'Pipeline Status' }, { name: 'FCST Summary' },
    { name: 'Pipeline Hygiene' }, { name: 'Pipeline Management' }, { name: 'Monthly Rev. & GM FCST' }
  ];
  return list.some(item => item.name === itemName);
}

// 차트 타입 정보 (표시여부, 옵션, 기본값)
export function getItemChartTypeInfo(itemName) {
  const whitelist = [
    { name: 'Total Rev. FCST', options: ['doughnut', 'vertical', 'horizontal'], default: 'doughnut' },
    { name: 'Total GM FCST', options: ['doughnut', 'vertical', 'horizontal'], default: 'doughnut' },
    { name: 'Rev. FCST', options: ['doughnut', 'vertical', 'horizontal'], default: 'doughnut' },
    { name: 'GM FCST', options: ['doughnut', 'vertical', 'horizontal'], default: 'doughnut' },
    { name: 'Monthly Rev. & GM FCST', options: ['vertical', 'horizontal'], default: 'vertical' },
    { name: 'Total Rev. & GM FCST Weekly History', options: ['line', 'bar'], default: 'line' },
  ];
  const chartConfig = whitelist.find(item => item.name === itemName);
  return {
    isShow: !!chartConfig,
    options: chartConfig?.options || [],
    default: chartConfig?.default || ''
  };
}

// 범례 정보 (표시여부, 옵션, 기본값)
export function getItemLegendInfo(itemName) {
  const whitelist = [
    { name: 'Total Rev. FCST', options: ['chief', 'stage', 'goods'] },
    { name: 'Total GM FCST', options: ['chief', 'stage', 'goods'] },
    { name: 'Rev. FCST', options: ['stage', 'goods'] },
    { name: 'GM FCST', options: ['stage', 'goods'] },
    { name: 'Monthly Rev. & GM FCST', options: ['enduser', 'goods', 'purchaser'] },
    { name: 'Total Rev. & GM FCST Weekly History', options: ['all'] },
  ];
  const legendConfig = whitelist.find(item => item.name === itemName);
  const options = legendConfig?.options || [];
  const mappedOptions = options
      .map(name => SELECT_OPTIONS_LEGEND.find(item => item.value === name))
      .filter(Boolean); // filter(Boolean)은 undefined/null 제거
    if (itemName === 'Total Rev. & GM FCST Weekly History'){
      mappedOptions.push(  { text: 'Q1', value: '1' },
                           { text: 'Q2', value: '2' },
                           { text: 'Q3', value: '3' },
                           { text: 'Q4', value: '4' })
    }
  // TODO: 주간 히스토리 분기별 옵션 추가 로직 필요 시 구현
  // if (itemName === 'Total Rev. & GM FCST Weekly History' && someQuarterData) { ... }

  return {
    isShow: !!legendConfig,
    options: mappedOptions, // {text, value} 객체 배열
    default: options.length > 0 ? options[0] : '' // 기본값 (value)
  };
}

// 직원 ID 그룹 1 (options3 내부) 표시 여부
export function shouldDisplayEmployeeIdGroup1(itemName, isAdmin) { // isAdmin 인자 추가
  const listForDisplay = [
    { name: 'Pipeline Status' }, { name: 'FCST Summary' },
    { name: 'Pipeline Hygiene' }, { name: 'Pipeline Management' },
    { name: 'Total Rev. & GM FCST Weekly History' }
  ];
  const isExcluded = itemName === 'Final Balance FCST';
  // isAdmin 로직은 여기서 직접 사용하지 않으나, 필요 시 조건 추가 가능
  return !isExcluded && listForDisplay.some(item => item.name === itemName);
}

// 직원 ID 그룹 2 (options3 외부) 표시 여부
export function shouldDisplayEmployeeIdGroup2(itemName, isAdmin) { // isAdmin 인자 추가
  const listForDisplay = [
    { name: 'Pipeline Status' }, { name: 'FCST Summary' },
    { name: 'Pipeline Hygiene' }, { name: 'Pipeline Management' },
    { name: 'Total Rev. & GM FCST Weekly History' }
  ];
  const isExcluded = itemName === 'Final Balance FCST';
  // isAdmin 로직은 여기서 직접 사용하지 않으나, 필요 시 조건 추가 가능
  return !isExcluded && !listForDisplay.some(item => item.name === itemName);
}

// 초기 직원 ID 값 반환
export function getInitialEmployeeId(userStore) { // userStore 인스턴스 필요
  if (!userStore || !userStore.user) return ''; // 방어 코드
  return userStore.isAdmin ? '' : userStore.user.employeeId;
}

// 차트 컴포넌트 결정
export function resolveChartComponent(itemName) {

  const charts = {
    'FCST Summary': FCSTSummary,
    'Pipeline Management': PipelineManagement,
    'Final Balance FCST': FinalBalanceFCST,
    'Pipeline Hygiene': PipelineHygiene,
    'Total Rev. FCST': TotalRevFCST,
    'Total GM FCST': TotalGMFCST,
    'Rev. FCST': RevFCST,
    'GM FCST': GMFCST,
    'Monthly Rev. & GM FCST': MonthlyRevGMFCST,
    'Pipeline Status': PipelineStatus,
    'Total Rev. & GM FCST Weekly History': WeeklyHistory,
  };
  return charts[itemName] || null; // 해당하는 컴포넌트가 없으면 null 반환
}

// 링크 리포트 경로 반환
export function getLinkReportPath(itemName) {
  const links = {
    'FCST Summary': "/rd/MRD_RT_001",
    'Pipeline Management': "/rd/MRD_RT_001",
    'Final Balance FCST': "/rd/MRD_RT_002",
    'Pipeline Hygiene': "/rd/MRD_RT_004",
    'Total Rev. FCST': "/rd/MRD_RT_001",
    'Total GM FCST': "/rd/MRD_RT_001",
    'Rev. FCST': "/rd/MRD_RT_001",
    'GM FCST': "/rd/MRD_RT_001",
    'Monthly Rev. & GM FCST': "/rd/MRD_RT_003",
    'Pipeline Status': "/rd/MRD_RT_001",
  };
  return links[itemName];
}